import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import DropDownList from 'Components/DropDownList/DropDownList';
import './Insights.scss';
import GroupSearch from 'Components/GroupSearch';
import { findItem } from 'Components/forms/select-input/SelectInput.jsx';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getExceptionQueue, getSubQueueList, getAssignedQueuesSummary, getUserGroups, getGroupAnalystDetails, getGroupCasesCount, getSubQueueCount, getQueueSummary, getQueueGroupList, getExcepionList, getMerchantImageAllRegionCount } from 'Apis/queueManagerApi.js';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import RefreshTimeBox from 'Components/RefreshTimeBox/RefreshTimeBox';
import EmptyState from 'Components/EmptyState/EmptyState';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { COLORS } from "Constants/BIDashboardConstants"
export class Insights extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [
                {
                    value: 0,
                    text: "All Analyst",
                },
            ],
            currentGroup: {
                value: 0,
                text: "All Analyst",
            },
            timeBoxData: {
                date: new Date(),
                isRefreshRequired: true,
                text: 'Last refreshed',
            },
            currentSearchTerm: "",
            regionDataList: [],
            selectedInput: [],
            emptyStateHeading: 'Unauthorized',
            emptyStateDescription: 'You are not authorized to view this content.',
            emptyStateNoPermissionsHeading: 'You do not have permission to view this page',
            emptyStateNoPermissionsDesc: 'Please contact support team for further assistance',
            userId: JSON.parse(sessionStorage.getItem('state')).auth.user.userId,
            acquirerAccessList: getAcquirerAccessList(),
            selectedGroup: { text: "Select Group" },
            pendingAnalyst: { label: "Pending Analyst", desc: "Displays all open disputes that are pending analyst action." },
            pendingMerchant: { label: "Pending Merchant", desc: "Displays all open disputes that are pending merchant action." },
            pendingInternal: { label: "Pending Internal", desc: "Displays all open disputes that are pending action from another party. Includes open pended cases." },
            exceptionQueues: [],
            isVisiblePendingAnalyst: false,
            isVisiblePendingMerchant: false,
            isVisiblePendingInternal: false,
            isLoading: true,
            actionCategoryCodeList: [
                { actionCode: "PDAN", stateName: "pendingAnalyst" },
                { actionCode: "PDMR", stateName: "pendingMerchant" },
                { actionCode: "PDIN", stateName: "pendingInternal" }
            ],
        }
    }

    componentDidMount() {
        this.getQueueGroupList();
        this.fetchUserGroups();
        this.getAssignedQueuesSummary();
    }

    getQueueGroupList = () => {
        let acquirerAccessList = this.state.acquirerAccessList
        let userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
        if (acquirerAccessList.length !== 0) {
            return getQueueGroupList(acquirerAccessList,userId)
                .then((apiResponse) => {
                    const formattedRegionList = apiResponse.data.map((item) => {
                        let regionListValue = { regionCode: item.queueGroupCode, acquirerAccessCode: item.acquirerAccessCode, isDefaultRegion: item.defaultRegion  };
                        return {
                            text: item.queueGroupLabel,
                            value: regionListValue,
                        };
                    });
                    
                    let defaultRegionIndex = formattedRegionList.findIndex(
                        (region) => region.value.isDefaultRegion == true
                      );
                      if (defaultRegionIndex == -1) {
                        defaultRegionIndex = 0;
                      }
                      
                    this.setState({
                        regionDataList: formattedRegionList,
                        selectedInput: formattedRegionList[defaultRegionIndex],
                    },
                        () => {
                            this.getSubQueueList(formattedRegionList[defaultRegionIndex].value.regionCode)
                            this.getExcepionList(formattedRegionList[defaultRegionIndex].value.regionCode)
                            this.getQueueSummary({ selectedInput: formattedRegionList[defaultRegionIndex] });
                        });

                }).catch((error) => {
                    this.setState({ dataErr: true });
                    console.log('error received while fetching data columns based on queue page', error);
                });
        }
    }

    handleSelectionChange = (selectedItem) => {
        if (selectedItem && selectedItem.value.regionCode != this.state.selectedInput.value.regionCode) {
            this.setState({ selectedInput: selectedItem },
                () => {
                    this.getSubQueueList(selectedItem.value.regionCode);
                    this.getExcepionList(selectedItem.value.regionCode);
                    this.getQueueSummary();
                });
        }
    }
    getQueueSummary = () => {
        this.state.actionCategoryCodeList.forEach(item => {
            getQueueSummary(this.state.selectedInput?.value.regionCode, item.actionCode, this.state.userId, null, null, this.state.acquirerAccessList).then((response) => {
                this.setState({
                    [item.stateName]: { ...this.state[item.stateName], totalCount: response.data.workableCount }
                });
            }).catch((error) => {
                this.setState({ dataErr: true });
                console.log('error received while fetching data columns based on queue page', error);
            });
        })

    }

    getSubQueueList = (regionCode) => {
        this.state.actionCategoryCodeList.map((item, index) => {
            getSubQueueList(item.actionCode, regionCode, true).then((response) => {
                let customQueueIdList = response.data.map(item => item.customQueueId);
                let prev = this.state[item.stateName];
                this.setState({ [item.stateName]: { ...prev, subQueueList: response.data, customQueueIdList } }, () => {
                    if (index == 2) {
                        setTimeout(() => {
                            this.getSubQueueCount();
                        }, 550)
                    }
                });
            }).catch((error) => {
                console.log('error received while fetching sub queues', error);
            });
        })
    }

    getSubQueueCount = () => {
        this.setState({ isLoading: true })
        let threshould = 5;
        let threshouldArray = [];
        let actionsCodeList = {
            pendingAnalyst: [],
            pendingMerchant: [],
            pendingInternal: [],
        }

        this.state.actionCategoryCodeList.forEach(i => {
            this.state[i.stateName]?.customQueueIdList?.forEach((item, index, array) => {
                threshouldArray?.push(item);
                if (threshouldArray.length == threshould || (array.length == index + 1)) {
                    actionsCodeList[i?.stateName]?.push(threshouldArray)
                    threshouldArray = [];
                }
            })
        })

        this.state.actionCategoryCodeList.forEach((i, index, array) => {
            actionsCodeList[i?.stateName]?.forEach((bunch) => {
                getSubQueueCount(bunch).then(response => {
                    let subQueueList = this.state[i.stateName].subQueueList?.map((subQue) => {
                        if (response?.data.queueCountMap[subQue?.customQueueId]) {
                            return {
                                ...subQue,
                                caseCount: response.data.queueCountMap[subQue?.customQueueId]
                            };
                        } else {
                            return {
                                ...subQue,
                                caseCount: subQue?.caseCount > 0 ? subQue.caseCount : "0"
                            };
                        }
                    })

                    this.setState({
                        [i.stateName]: { ...this.state[i.stateName], subQueueList },
                    }, () => {
                        if (index + 1 == array.length) {
                            this.setState({ isLoading: false })
                        }
                    })
                }).catch((error) => {
                    this.setState({ dataErr: true, isLoading: false });
                    console.log('error received while fetching sub queues', error);
                });
            })
        })
    }

    getExcepionList(regionCode) {
        let acquirerAccessList = getAcquirerAccessList();
        getExceptionQueue(acquirerAccessList).then((apiResponse) => {
            getExcepionList(regionCode, acquirerAccessList).then(resp => {
                getMerchantImageAllRegionCount(acquirerAccessList).then(expResp => {
                    let exceptionQueues = resp.data.map(item => {
                        let queue = [...apiResponse.data, ...expResp.data].filter(i => i.queueName == item.queueLabel);
                        return {
                            queueName: item.queueLabel,
                            count: queue ? queue[0] ? queue[0].count : null : null
                        }
                    })
                    this.setState({ exceptionQueues });
                })
            })
        }).catch((error) => {
            this.setState({ xceptionQueues: [], dataErr: true });
            console.log('error received while fetching data columns based on queue page', error);
        });
    }

    togglePane = (key) => {
        switch (key) {
            case "Pending-Analyst":
                document.body.classList.add('instant-header');
                this.setState({ isVisiblePendingAnalyst: !this.state.isVisiblePendingAnalyst, });
                break;
            case "Pending-Merchant":
                document.body.classList.add('instant-header');
                this.setState({ isVisiblePendingMerchant: !this.state.isVisiblePendingMerchant, });
                break;
            case "Pending-Internal":
                document.body.classList.add('instant-header');
                this.setState({ isVisiblePendingInternal: !this.state.isVisiblePendingInternal, });
                break;

            default:
                break;
        }
    }

    onChangeSearch = (item) => {
    }

    fetchAssignedCasesCount = (count) => {
        this.setState({
            assignedQueueSummary: count
        });
    }

    fetchUserGroups = () => {
        let userGroups = [];
        let acquirerAccessList = getAcquirerAccessList();
        return getUserGroups(acquirerAccessList)
            .then((apiResponse) => {
                apiResponse.data.forEach(group => {
                    let groupItem = {
                        value: group.userGroupId,
                        text: group.userGroupName,
                        acquirer: group.acquirerCode,
                    }
                    userGroups = userGroups.concat([groupItem]);
                });
                let stateGroups = [...this.state.groups];
                stateGroups = stateGroups.concat(userGroups);
                this.setState({
                    groups: stateGroups,
                    dataErr: false,
                });
            })
            .catch((error) => {
                this.setState({ dataErr: true });
                console.log('Error occured while fetching user groups: ', error);
            });
    }

    checkIfGroupPresent = () => {
        if(this.state.groups.filter(e => e.value!==0).length === 0){
            return true;
        }else{
            return false;
        }
    };

    selectGroup = (value) => {
        const groups = this.state.groups;
        const selectedGroup = findItem(groups, value);
        if (selectedGroup) {
            this.setState({ currentGroup: selectedGroup });
            let groupId;
            let acquirer;
            if (selectedGroup.value === 0) {
                groupId = null;
                acquirer = this.getAcquirerAccessList();
            } else {
                groupId = selectedGroup.value;
                acquirer = selectedGroup.acquirer;
            }
            this.fetchGroupAnalystsDetails(groupId, acquirer);
            this.fetchGroupCasesCount(groupId, acquirer);
        }
    }
    fetchGroupAnalystsDetails = (userGroupId, acquirer) => {
        return getGroupAnalystDetails(userGroupId, acquirer)
            .then((apiResponse) => {
                this.setState({ dataErr: false });
                this.setUniqueGroupAnalysts(apiResponse.data);
            })
            .catch((error) => {
                this.setState({ dataErr: true });
                console.log('Error occured while fetching user details: ', error);
            });
    }
    fetchGroupCasesCount = (userGroupId, acquirer) => {
        return getGroupCasesCount(userGroupId, acquirer)
            .then((apiResponse) => {
                this.setState({ dataErr: false });
                // this.fetchAssignedCasesCount(apiResponse.data);
            })
            .catch((error) => {
                this.setState({ dataErr: true });
                console.log('Error occured while fetching assigned cases count: ', error);
            })
    }
    searchAnalysts = (value) => {
        this.setState({
            currentSearchTerm: value,
        });
    }

    refreshTimeFeed = () => {
        // call methos which are called in willmoun or didmount
        this.getQueueGroupList();
        this.getAssignedQueuesSummary();
        this.getQueueSummary();

        const timeBoxDataClone = { ...timeBoxDataClone };
        timeBoxDataClone.date = new Date();
        timeBoxDataClone.isRefreshRequired = true;
        timeBoxDataClone.text = 'Last refreshed';
        this.setState({
            timeBoxData: timeBoxDataClone,
            isLoading: true
        });
    }

    getAssignedQueuesSummary = () => {
        /**
         * Thid method returns count of of cases in assigned queus
         */
        let acquirerAccessList = getAcquirerAccessList();
        if (acquirerAccessList.length !== 0) {
            getAssignedQueuesSummary(acquirerAccessList).then((response) => {
                this.setState({
                    assignedQueueSummary: response.data,
                });
            }).catch((error) => {
                this.setState({ dataErr: true });
                console.log('error received while fetching data columns based on queue page', error);
            });
        }
    }

    render() {
        window.document.title = this.state.selectedInput.text ? `${this.state.selectedInput.text} Insights` : 'Insights';
        let acquirerList = getAcquirerAccessList();
        if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.seeStatsForQueue && acquirerList.length !== 0) {
            return (
                <section className="case-landing-container-new" >
                    <div className="main-content--header secondary-header">
                        {!this.state.dataErr && <div className="flex-left">
                            <div><h1 className="title">Home</h1></div>
                            {this.state.selectedInput.text &&
                                <div className="region-dropdown-view">
                                    <DropDownList
                                        key={"DropDownList-insights"}
                                        dropDownList={this.state.regionDataList}
                                        selectedItemText={this.state.selectedInput.text}
                                        selectDropdownItem={this.handleSelectionChange}
                                        extraStyle={{ left: 5, width: 150 }}
                                        wrapperButtonStyle={{ left: 0, width: 'max-content', backgroundColor: '#f4f4f4' }}
                                        isFocus={false}
                                    />
                                </div>
                            }
                        </div>}
                        {!this.state.dataErr && <div className="flex-right">
                            <RefreshTimeBox
                                key={"refreshTimeBox-Insights"}
                                timeBoxData={this.state.timeBoxData}
                                refreshTimeFeed={this.refreshTimeFeed}
                                version="2"
                            />
                        </div>}
                    </div>

                    { this.state.isLoading && <BVLoader20 key="bvloader20-insights" />}

                    { this.state.dataErr &&
                        <div className="dataError">
                            <span><h2>Nothing to display</h2></span>
                        </div>
                    }

                    {/* Pendeing Analyst */}
                    { !this.state.isLoading && !this.state.dataErr && <div className="sub-queue-container">
                        <div className="flex flex-between action-lable">
                            <div className="">
                                <span className="action-header">
                                    {this.state.pendingAnalyst.label}
                                </span>
                                <div className="action-description">
                                    {this.state.pendingAnalyst.desc}
                                </div>
                            </div>
                            <div className="border-left px-10">
                                <div className="f-11 text-gray fw-500">Total</div>
                                <div>
                                    <span className="f-18 fw-500" style={{ color: `${COLORS.oneGp.black}` }}>{this.state.pendingAnalyst?.totalCount ? this.state.pendingAnalyst?.totalCount : "0"}</span>
                                    <InformationBubble
                                        key={"informationBubble-insights-1"}
                                        info
                                        tooltipContent={"Total unique cases found"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="grid click-panel" onClick={() => this.togglePane("Pending-Analyst")} >
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingAnalyst ? 'active' : ''}`}>
                                <span>PRIORITY</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingAnalyst ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingAnalyst ? 'active' : ''}`}>
                                <span>DEFAULT</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingAnalyst ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingAnalyst ? 'active' : ''}`}>
                                <span>SPECIALTY</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingAnalyst ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                        </div>
                        <div className={this.state.isVisiblePendingAnalyst ? "show-panel" : "hide-panel"}>
                            <div className="grid">
                                <div className="col-4 sub-queue">
                                    {this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.length > 0 && this.state.pendingAnalyst.subQueueList?.filter(i => i.queueCategoryCode == "Priority")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>

                                <div className="col-4 sub-queue">
                                    {this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.length > 0 && this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>

                                <div className="col-4 sub-queue">
                                    {this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.length > 0 && this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingAnalyst.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {/* Pending Merchant */}
                    { !this.state.isLoading && !this.state.dataErr && <div className="sub-queue-container">
                        <div className="flex flex-between action-lable">
                            <div>
                                <span className="action-header">
                                    {this.state.pendingMerchant.label}
                                </span>
                                <div className="action-description">
                                    {this.state.pendingMerchant.desc}
                                </div>
                            </div>
                            <div className="border-left px-10">
                                <div className="f-11 text-gray fw-500">Total</div>
                                <div>
                                    <span className="f-18 fw-500" style={{ color: `${COLORS.oneGp.black}`  }}>{this.state.pendingMerchant?.totalCount ? this.state.pendingMerchant?.totalCount : "0"}</span>
                                    <InformationBubble
                                        key={"informationBubble-insights-2"}
                                        info
                                        tooltipContent={"Total unique cases found"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="grid click-panel" onClick={() => this.togglePane("Pending-Merchant")} >
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingMerchant ? 'active' : ''}`}>
                                <span>PRIORITY</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingMerchant ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingMerchant ? 'active' : ''}`}>
                                <span>DEFAULT</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingMerchant ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingMerchant ? 'active' : ''}`}>
                                <span>SPECIALTY</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingMerchant ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                        </div>
                        <div className={this.state.isVisiblePendingMerchant ? "show-panel" : "hide-panel"}>
                            <div className="grid">
                                <div className="col-4 sub-queue">
                                    {this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.length > 0 && this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>

                                <div className="col-4 sub-queue">
                                    {this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.length > 0 && this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>

                                <div className="col-4 sub-queue">
                                    {this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.length > 0 && this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingMerchant.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {/* Pending Internal */}
                    { !this.state.isLoading && !this.state.dataErr && <div className="sub-queue-container">
                        <div className="flex flex-between action-lable">
                            <div>
                                <div className="action-header">
                                    {this.state.pendingInternal.label}
                                </div>
                                <div className="action-description">
                                    {this.state.pendingInternal.desc}
                                </div>
                            </div>
                            <div className="border-left px-10">
                                <div className="f-11 text-gray fw-500">Total</div>
                                <div>
                                    <span className="f-18 fw-500" style={{ color: `${COLORS.oneGp.black}`  }}>{this.state.pendingInternal?.totalCount ? this.state.pendingInternal?.totalCount : "0"}</span>
                                    <InformationBubble
                                        key={"informationBubble-insights-3"}
                                        info
                                        tooltipContent={"Total unique cases found"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="grid click-panel" onClick={() => this.togglePane("Pending-Internal")} >
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingInternal ? 'active' : ''}`}>
                                <span>PRIORITY</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingInternal ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingInternal ? 'active' : ''}`}>
                                <span>DEFAULT</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingInternal ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                            <span className={`col-4 sub-title ${this.state.isVisiblePendingInternal ? 'active' : ''}`}>
                                <span>SPECIALTY</span>
                                <span className="float-right">
                                    <span className={this.state.isVisiblePendingInternal ? "arrow-up" : "arrow-down"}></span>
                                </span>
                            </span>
                        </div>
                        <div className={this.state.isVisiblePendingInternal ? "show-panel" : "hide-panel"}>
                            <div className="grid">
                                <div className="col-4 sub-queue">
                                    {this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.length > 0 && this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Priority")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>

                                <div className="col-4 sub-queue">
                                    {this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.length > 0 && this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Default")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>

                                <div className="col-4 sub-queue">
                                    {this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.length > 0 && this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.map(item => {
                                        return (
                                            <div className="grid border-bottom bg-mist py-13 px-10">
                                                <span className="col-9 queue-label"> {item?.queueLabel} </span>
                                                <span className="col-2 count"> {item?.caseCount} </span>
                                                <span className="col-1"></span>
                                            </div>
                                        )
                                    })
                                    }
                                    {this.state.pendingInternal.subQueueList?.filter(i => i?.queueCategoryCode == "Specialty")?.length == 0 &&
                                        <div className="nothing-to-display">Nothing to display</div>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                    }
                    {/* Exception, Select and search Analyst */}
                    { !this.state.isLoading && !this.state.dataErr && <div className="grid sub-queue-container">
                        <div className="col-5 f-18 fw-500 ">Exception Queues</div>
                        <div className="col-2 "></div>
                        <div className="col-5 f-18 fw-500 ">Assigned Cases</div>
                        <div className="col-5 mt-20 ">
                            {this.state.exceptionQueues?.length > 0 &&
                                this.state.exceptionQueues.map(item => {
                                    return (
                                        <div className="grid border bg-white py-13 px-10">
                                            <span className="col-9 sub-queue-label"> {item?.queueName} </span>
                                            <span className="col-2  count"> {item?.count ? item?.count : "0"} </span>
                                            <span className="col-1 "></span>
                                        </div>
                                    )
                                })
                            }
                            {this.state.exceptionQueues?.length == 0 &&
                                <div className="nothing-to-display" style={{ marginLeft: "-50%" }}>Nothing to display</div>
                            }
                        </div>
                        <div className="col-2 "></div>
                        <div className="col-5 my-20 bg-white">
                            <div>
                                <div className="border-1 bg-white px-15 py-5">
                                    <div className="fw-400 f-12 text-light-gray">Total Assigned</div>
                                    <div className="fw-400 f-18">{this.checkIfGroupPresent() ? '0' : this.state?.assignedQueueSummary?.availableToWorkCount}</div>
                                </div>
                            </div>
                            <div>
                                <GroupSearch
                                    key={"GroupSearch-insights"}
                                    fetchAssignedCasesCount={this.fetchAssignedCasesCount}
                                    defaultGroupTitle='All Analysts'
                                    selectionTitle='Groups'
                                    searchTitle='Search'
                                    searchPlaceholder='Search For Analysts'
                                    isGroupPresent={this.checkIfGroupPresent()}
                                    groupNotAvailableMessage='Not Available'
                                />
                            </div>
                        </div>
                    </div>
                    }
                </section>
            );
        } else {
            return (
                <div>
                    <EmptyState
                        translations={{
                            emptyStateHeading: acquirerList.length === 0 && this.props.user.parsedPermissions.queue.seeStatsForQueue ? this.state.emptyStateNoPermissionsHeading : this.state.emptyStateHeading,
                            emptyStateDescription: acquirerList.length === 0 && this.props.user.parsedPermissions.queue.seeStatsForQueue ? this.state.emptyStateNoPermissionsDesc : this.state.emptyStateDescription
                        }}
                    />
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default withRouter(connect(mapStateToProps)(Insights));
